import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NgModule, Injector, APP_INITIALIZER } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { AuthModule } from './@auth/auth.module';
import { CoreModule } from './@core/core.module';
import { InitUserService } from './@theme/services/init-user.service';

import { ConsoleLoggerService } from './insurgo-services/logging/console-logger.service';
import { LoggerService } from './insurgo-services/logging/logger.service';

import { AddressService } from './insurgo-services/address.service';
import { CompanyService } from './insurgo-services/company.service';
import { UserService } from './insurgo-services/user.service';

import { ButtonRendererComponent } from './insurgo-services/cellRenderers/button.renderer.component';

import { ModalServiceModule } from './insurgo-services/modalTemplates/modal-service.module';
import { ManagementModule } from './insurgo-pages/management/management.module';

import { MainPipeModule } from './insurgo-ui-components/pipes/pipes-module'

import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbIconModule,
  NbButtonModule,
  NbTooltipModule
} from '@nebular/theme';

import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ScannerHelperService } from './insurgo-services/scanner-helper.service';

import { ConfigurationService } from './insurgo-services/configuration.service';
import { CheckboxRenderer } from './insurgo-services/cellRenderers/checkbox.renderer.component';

export function init_app(injector: Injector) {
  return () =>
    new Promise<any>((resolve: Function) => {
        const initUserService = injector.get(InitUserService);
        initUserService.initCurrentUser().subscribe(() => {

        },
          () => resolve(), () => resolve()); // a place for logging error
    });
}

@NgModule({ declarations: [
        AppComponent,
        ButtonRendererComponent,
        CheckboxRenderer
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ButtonsModule,
        InputsModule,
        DropDownsModule,
        AppRoutingModule,
        AuthModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbButtonModule,
        NbTooltipModule,
        NbIconModule,
        NbEvaIconsModule,
        AgGridAngular,
        MainPipeModule,
        CoreModule.forRoot(),
        ModalServiceModule,
        ManagementModule,
        ThemeModule.forRoot()], providers: [
        ConfigurationService,
        {
            provide: APP_INITIALIZER,
            useFactory: (configService: ConfigurationService) => () => configService.setConfigurationSettings(),
            deps: [ConfigurationService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [Injector],
            multi: true,
        },
        {
            provide: LoggerService,
            useClass: ConsoleLoggerService
        },
        AddressService,
        CompanyService,
        UserService,
        ScannerHelperService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
